import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';

import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { MsalModule, MsalRedirectComponent, MsalInterceptor } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';

registerLocaleData(en);

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader:{
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MsalModule.forRoot( new PublicClientApplication({
      auth: {
        // clientId: '3782f9bd-9ea5-4200-a894-6b50f6cea2fe', // This is your client ID
        // authority: 'https://login.microsoftonline.com/e92a8d73-8c26-43bf-a704-6184973a7bad', // This is your tenant ID
        //  redirectUri: 'https://ada.m4dgcr.com/authentication'// This is your redirect URI
        clientId: 'd0213819-7751-4e9b-8e78-6a9263554788', // This is your client ID
        authority: 'https://login.microsoftonline.com/e92a8d73-8c26-43bf-a704-6184973a7bad', // This is your tenant ID
        redirectUri: 'http://localhost:4200/authentication',// This is your redirect URI
        postLogoutRedirectUri: 'http://localhost:4200/authentication'
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
      }
    }), null, null)
  ],
  providers: [{ provide: NZ_I18N, useValue: en_US },
 // {provide:HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi:true}
],
  bootstrap: [AppComponent,MsalRedirectComponent]
})
export class AppModule { }
